import {AnalyticsService} from './../analytics/analytics.service';
import {inject, Injectable} from '@angular/core';
import {MotorQuoteDTO} from '../../models/MotorQuoteDTO.interfaces';
import {distinctUntilChanged, filter, Subject, tap} from 'rxjs';
import {ThankYouPages} from '../../enums/thank-you-pages.enum';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {PermissionService} from '../permission/permission.service';

@Injectable({
  providedIn: 'root',
})
export class RouterDataService {
  //TODO implement Observable and static methods. Possibly put an interceptor or something in between API to
  //assign motorQuoteObject automatically whenever BE reply with such object. Also, stepResponseService needs a refactory
  //to let motorQuoteObject-dipendent components be asyncronous with every change of data.
  private motorQuoteObject!: MotorQuoteDTO;
  private motorQuoteObject$: Subject<MotorQuoteDTO> = new Subject();
  private thankYouFlow?: ThankYouPages;
  private continueEmitting = true;

  private analyticsService = inject(AnalyticsService);
  private permissionService = inject(PermissionService);

  constructor() {
    /* if (!environment.production)
      this.mockDataForDevelopement().subscribe((data) =>
        this.setMotorQuoteObject(data as MotorQuoteDTO),
      ); */
  }

  mockDataForDevelopement() {
    const httpClient = inject(HttpClient);
    return httpClient.get('./assets/mock/init.json');
  }

  setMotorQuoteObject(motorQuoteToSet: MotorQuoteDTO, continueEmitting?: boolean) {
    if (typeof continueEmitting !== 'undefined') {
      this.continueEmitting = continueEmitting;
    }
    this.motorQuoteObject = motorQuoteToSet;
    this.permissionService.setBuyPermissionFromMotor(this.motorQuoteObject);
    this.analyticsService.updateQuote(motorQuoteToSet);
    this.motorQuoteObject$.next(motorQuoteToSet);
    console.log("MotorQuoteObject set: ", motorQuoteToSet);
  }

  getMotorQuoteObject() {
    return this.motorQuoteObject;
  }
  getMotorQuoteObjectAsObservable() {
    this.continueEmitting = true;
    return this.motorQuoteObject$.asObservable().pipe(
      filter((_) => this.continueEmitting),
      distinctUntilChanged(),
    );
  }

  setThankYouFlow(flow?: ThankYouPages) {
    this.thankYouFlow = flow;
  }
  getThankYouFlow() {
    return this.thankYouFlow;
    // return ThankYouPages.PAYMENT_KO;
  }
}
